import { React } from "react"
import { Box, styled, Typography, IconButton, getAppBarUtilityClass, CardMedia } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import Swal from "sweetalert2"
import { blue } from "@mui/material/colors"
const Detalle = styled(Box)({
  width: "100%",
  overflowY: "auto",
  padding: 10,
  gridArea: "Detalle",
  border: "1px solid #ddd",
  borderRadius: "0 0 10px 10px",
  backgroundColor: "#f9f9f9",
})

const ShoppingDetail = ({ setProductosSeleccionados, productosSeleccionados }) => {
  // Referencia para Articulos

  const handleIncrementQuantity = (productName) => {
    setProductosSeleccionados((prevProducts) =>
      prevProducts.map((p) => {
        if (p.artcodigo === productName) {
          if (p.cantidad < p.artcantactual) {
            // Incrementa la cantidad solo si es menor que el stock actual
            return { ...p, cantidad: p.cantidad + 1 }
          } else {
            // Muestra una advertencia si la cantidad excede el stock actual
            Swal.fire({
              title: "Stock insuficiente",
              text: `No hay suficiente stock disponible para ${p.artdescri}.`,
              icon: "warning",
              button: "Entendido",
            })
          }
        }
        return p
      }),
    )
  }

  const handleEliminar = (productoCod) => {
    setProductosSeleccionados(
      (prevProducts) => prevProducts.filter((p) => p.artcodigo !== productoCod), // Remueve productos con cantidad 0
    )
  }
  const handleDecrementQuantity = (productName) => {
    setProductosSeleccionados(
      (prevProducts) =>
        prevProducts
          .map((p) => (p.artcodigo === productName && p.cantidad > 1 ? { ...p, cantidad: p.cantidad - 1 } : p))
          .filter((p) => p.cantidad > 0), // Remueve productos con cantidad 0
    )
  }
  const calculateTotalPrice = () => {
    return productosSeleccionados
      .reduce((total, product) => total + product.precioUnitario * product.cantidad, 0)
      .toFixed(2)
  }
  return (
    <>
      <Detalle>
        <Box style={{ marginTop: 0, fontWeight: "bold", fontSize: "16px", color: "rgb(25, 108, 135)" }}>
          <Typography>Productos de la Proforma</Typography>
        </Box>
        {/* Check if there are selected products */}
        {productosSeleccionados.length === 0 ? (
          <Typography>No hay productos en el detalle</Typography>
        ) : (
          productosSeleccionados.map((product) => (
            //  caja principal de todo ordenada en filas
            <Box
              key={product.artcodigo}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "10px",
                backgroundColor: "white",
                padding: 2,
                gap: 1,
                margin: 10,
              }}
            >
              {/* primer elemento del flex  */}
              <CardMedia
                key={product.artcodigo} // Asigna un key único para cada imagen
                component="img"
                style={{ maxHeight: "100%", objectFit: "contain", width: "50px" }}
                image={`data:image/jpeg;base64,${product?.imagen?.[0] ?? ""}`}
                alt="Imagen no disponible"
              />
              {/* segundo elemento nombre y precio  */}
              <Box style={{ display: "flex", flexDirection: "column", alignItems: "left", margin: 5, flex: "0 auto" }}>
                <Typography style={{ flex: 1 }}>{product.artdescri}</Typography>
                <Typography style={{ flex: 1, fontSize: 10 }}>
                  ${parseFloat(product?.precioUnitario ?? "0.00").toFixed(2)}
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    alignSelf: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    flex: "0 auto",
                  }}
                >
                  <IconButton onClick={() => handleDecrementQuantity(product.artcodigo)}>
                    <RemoveCircleIcon></RemoveCircleIcon>
                  </IconButton>
                  <Typography style={{ backgroundColor: "white", padding: "5" }}>{product.cantidad}</Typography>
                  <IconButton onClick={() => handleIncrementQuantity(product.artcodigo)}>
                    <AddCircleIcon></AddCircleIcon>
                  </IconButton>
                </Box>
              </Box>

              {/* cuarto elemento total  */}
              <Typography style={{ flex: "0 auto" }}>
                ${(product.precioUnitario * product.cantidad).toFixed(2)}
              </Typography>
              {/* quinto elemento delete */}
              <IconButton
                onClick={() => handleEliminar(product.artcodigo)}
                style={{ color: "#e8330c", flex: "0 auto" }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))
        )}
        <Box style={{ marginTop: "20px", fontWeight: "bold" }}>
          <Typography>Total: ${calculateTotalPrice()}</Typography>
        </Box>
      </Detalle>
    </>
  )
}

export default ShoppingDetail
